<script>
import ModalBus from '@/eventBus'

export default {
  name: 'PaidPopup',

  props: {
    type: {
      type: String,
      default: 'error',
    },
  },

  computed: {
    isSuccess() {
      return this.type === 'success'
    },
  },

  methods: {
    closePopup() {
      ModalBus.emit('close')
    },
  },
}
</script>

<template>
  <div class="w-11/12 rounded-xl bg-white">
    <div class="flex items-center justify-between border-b-2 border-light/25 p-5">
      <span class="max-w-10/12 font-poppins text-xl font-medium lg:text-secondary">
        {{ isSuccess ? $t('premium.paidPopup.success.title') : $t('premium.paidPopup.error.title') }}
      </span>
      <button
        class="relative h-10 w-10 rounded-full bg-secondary focus:outline-none"
        @click="closePopup">
        <div
          class="absolute left-1/2 top-1/2 flex h-1/2 w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col items-end justify-between">
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full rotate-45 rounded bg-white"></div>
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full -rotate-45 rounded bg-white"></div>
        </div>
      </button>
    </div>
    <div class="p-5">
      <div class="flex w-full items-center rounded-xl border border-primary px-2 py-4">
        <svg
          class="mr-4 h-auto w-8"
          fill="none"
          height="31"
          viewBox="0 0 31 31"
          width="31"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M25.4042 20.3575L21.7245 23.6772L20.6932 22.1821C20.4247 21.7915 19.8877 21.6939 19.4972 21.9624C19.1066 22.2309 19.009 22.7679 19.2775 23.1585L20.8702 25.459C21.0594 25.6787 21.2791 25.8374 21.5781 25.8313C21.7917 25.8313 21.993 25.752 22.1578 25.6116L26.5637 21.6329C26.9176 21.3155 26.942 20.7724 26.6247 20.4185C26.3074 20.0646 25.7582 20.034 25.4042 20.3575Z"
            fill="#469752" />
          <path
            d="M31 2.5813C31 1.15945 29.8406 0 28.4187 0H2.5813C1.15945 0 0 1.15945 0 2.5813V18.1972C0 19.6191 1.15945 20.7785 2.5813 20.7785H15.2803C15.0789 21.4803 14.963 22.2187 14.963 22.9815C14.963 27.3996 18.5573 31 22.9815 31C27.4057 31 31 27.4057 31 22.9815C31 21.8831 30.7742 20.8335 30.3715 19.8754C30.7681 19.4116 31 18.8258 31 18.1972V2.5813ZM22.9815 29.2791C19.5093 29.2791 16.69 26.4537 16.69 22.9876C16.69 19.5154 19.5154 16.6961 22.9815 16.6961C26.4476 16.6961 29.273 19.5215 29.273 22.9876C29.2791 26.4537 26.4537 29.2791 22.9815 29.2791ZM29.2791 18.0325C27.8085 16.1652 25.5384 14.963 22.9876 14.963C19.9913 14.963 17.3795 16.6167 16.0065 19.0577H2.5813C2.10531 19.0577 1.72087 18.6732 1.72087 18.1972V2.5813C1.72087 2.10531 2.10531 1.72087 2.5813 1.72087H28.4126C28.8886 1.72087 29.273 2.10531 29.273 2.5813V18.0325H29.2791Z"
            fill="#469752" />
          <path
            d="M4.4366 10.2337H9.0744C9.55038 10.2337 9.93483 9.84921 9.93483 9.37323V4.73543C9.93483 4.25945 9.55038 3.875 9.0744 3.875H4.4366C3.96062 3.875 3.57617 4.25945 3.57617 4.73543V9.37323C3.57617 9.84921 3.96062 10.2337 4.4366 10.2337ZM5.29704 5.59587H8.21397V8.5128H5.29704V5.59587Z"
            fill="#469752" />
          <path
            d="M5.92558 13.4008H4.4366C3.96062 13.4008 3.57617 13.7852 3.57617 14.2612C3.57617 14.7372 3.96062 15.1216 4.4366 15.1216H5.92558C6.40157 15.1216 6.78601 14.7372 6.78601 14.2612C6.78601 13.7852 6.40157 13.4008 5.92558 13.4008Z"
            fill="#469752" />
          <path
            d="M10.9051 13.4008H9.4161C8.94011 13.4008 8.55566 13.7852 8.55566 14.2612C8.55566 14.7372 8.94011 15.1216 9.4161 15.1216H10.9051C11.3811 15.1216 11.7655 14.7372 11.7655 14.2612C11.7655 13.7852 11.3811 13.4008 10.9051 13.4008Z"
            fill="#469752" />
          <path
            d="M15.8846 13.4008H14.3956C13.9196 13.4008 13.5352 13.7852 13.5352 14.2612C13.5352 14.7372 13.9196 15.1216 14.3956 15.1216H15.8846C16.3605 15.1216 16.745 14.7372 16.745 14.2612C16.745 13.7852 16.3605 13.4008 15.8846 13.4008Z"
            fill="#469752" />
          <path
            d="M25.9593 3.875H19.5396C19.0636 3.875 18.6792 4.25945 18.6792 4.73543C18.6792 5.21142 19.0636 5.59587 19.5396 5.59587H25.9654C26.4414 5.59587 26.8259 5.21142 26.8259 4.73543C26.8259 4.25945 26.4353 3.875 25.9593 3.875Z"
            fill="#469752" />
        </svg>
        <p class="font-sans text-sm font-bold text-primary">
          {{
            isSuccess
              ? $t('premium.paidPopup.success.panel', { name: $data.appName })
              : $t('premium.paidPopup.error.panel', { name: $data.appName })
          }}
        </p>
      </div>

      <p
        v-if="isSuccess"
        class="mt-4 text-light"
        v-html="$t('premium.paidPopup.success.description')"></p>
      <div class="mt-8 flex w-full flex-col">
        <button
          class="btn mb-4 w-full"
          @click="closePopup">
          {{ $t('buttons.backToTheActivity') }}
        </button>
      </div>
    </div>
  </div>
</template>
